const academicTitleType = require('../enums/titles/academicTitleType')
const titleType = require('../enums/titles/titleType')

module.exports = function getFullNameFromCustomer (customer) {
  if (customer.name.ANR === titleType.F.api) {
    return [customer.name.NAM, customer.address.ZUSATZ1, customer.address.ZUSATZ2, customer.address.ZUSATZ3].filter(p => p).join(' ')
  }
  return `${customer.name.TI1 ? academicTitleType[customer.name.TI1].human + ' ' : ''}${customer.name.VOR} ${customer.name.NAM}`
}
